import { render, staticRenderFns } from "./secondTab.vue?vue&type=template&id=8d5c0232&scoped=true"
import script from "./secondTab.vue?vue&type=script&lang=js"
export * from "./secondTab.vue?vue&type=script&lang=js"
import style0 from "./secondTab.vue?vue&type=style&index=0&id=8d5c0232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5c0232",
  null
  
)

export default component.exports